export const GET_POSTS = 'GET_POSTS'
export const SET_SINGLE = 'SET_SINGLE'



// WEBPACK FOOTER //
// ./src/store/actionTypes.js